<template>
  <v-dialog
    v-model="isDialogVisible"
    persistent
    width="500"
  >
    <v-card>
      <v-card-title class="headline">
        Agregar AddOns
      </v-card-title>
      <v-card-text v-if="booking">
        <booking-data
          :booking="booking"
        />
      </v-card-text>
      <v-card-text>
        <v-form
          ref="form"
          @submit.prevent="onSubmit"
        >
          <!-- #### Name ############## -->
          <v-text-field
            v-model="itemData.name"
            outlined
            dense
            :rules="[validators.required]"
            label="Nombre del AddOn"
            hide-details="auto"
            class="mb-6"
            no-controls
          />
          <!-- #### Amount ############## -->
          <v-text-field
            v-model="itemData.amount"
            outlined
            dense
            :rules="[validators.required, validators.decimal]"
            label="Importe"
            hide-details="auto"
            hint="123.45"
            class="mb-6"
            no-controls
          />
          <!-- #### Quantity ############## -->
          <numeric-up-down
            v-model="itemData.quantity"
            label="Cantidad"
            :min="1"
          />
          <!-- #### Notas ############## -->
          <notes-textarea
            ref="notesTextarea"
            source="addons"
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          class="me-3"
          type="submit"
          @click="OnSubmit()"
        >
          Agregar
        </v-btn>
        <v-btn
          color="secondary"
          outlined
          type="reset"
          @click="isDialogVisible = false"
        >
          Cancelar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { ref } from '@vue/composition-api'
import { required, decimal } from '@core/utils/validation'

import store from '@/store'
import BookingData from '@/components/BookingData.vue'
import NotesTextarea from '@/components/controls/NotesTextarea.vue'
import NumericUpDown from '@/components/controls/NumericUpDown.vue'

export default {
  components: { BookingData, NotesTextarea, NumericUpDown },
  setup(_, { emit }) {
    const isDialogVisible = ref(false)

    const blankItemData = {
      bookingKey: null,
      name: null,
      amount: 0,
      quantity: 1,
    }
    const form = ref()
    const itemData = ref(JSON.parse(JSON.stringify(blankItemData)))
    const booking = ref()

    /** Notas */
    const notesTextarea = ref()

    /** Limpia todos los elementos del formulario, pero coloca
     * los "por default" a su valor inicial. */
    const ClearForm = () => {
      // Validamos que exista el elemento en el DOM
      // (Aplica para la primera vez que se muestra el diálogo)
      if (notesTextarea.value != null) {
        form.value.resetValidation()
        notesTextarea.value.Clear()
      }
      itemData.value = JSON.parse(JSON.stringify(blankItemData))
    }

    const ShowDialog = item => {
      ClearForm()
      itemData.value.bookingKey = item.bookingKey
      booking.value = item
      isDialogVisible.value = true
    }

    const OnSubmit = () => {
      if (form.value.validate()) {
        store.dispatch('addOns/apiCall', { mode: 'Insert', request: itemData.value }).then(result => {
          if (result.success) {
            // Guardamos las notas
            notesTextarea.value.Save({ sourceKey: result.data.addOnKey })

            emit('onInsert')
            isDialogVisible.value = false
          }
        })
      }
    }

    return {
      isDialogVisible,
      form,
      itemData,
      booking,
      OnSubmit,
      ShowDialog,

      // Notas
      notesTextarea,

      // Validación
      validators: { required, decimal },
    }
  },
}
</script>
